import type React from 'react';
import { shallowEqual } from 'react-redux';
import { useState } from 'react';
import Dialog from '../../../../../stories/Molecules/Dialog/Dialog';
import { useTypedSelector } from '../../../Store/connectors';
import Icon from '../../../../../stories/Atoms/Icon/Icon';

const SizeChart: React.FC = () => {
  const [dialogState, setDialogState] = useState({
    isLoading: false,
    isOpen: false,
  });
  const sizesPopupLink = useTypedSelector(
    ({ product }) => product.sizesPopupLink,
    shallowEqual,
  );

  if (sizesPopupLink === null) {
    return null;
  }

  const toggleDialog = (show: boolean) => {
    setDialogState({
      isLoading: show,
      isOpen: show,
    });
  };

  return (
    <>
      <div
        className="info-popup-link pointer"
        onClick={() => toggleDialog(true)}
      >
        <span className="ml-2">
          <Icon name="fa-circle-info" />
          {sizesPopupLink.text}
        </span>
      </div>
      {dialogState.isOpen && (
        <Dialog
          onClose={() => toggleDialog(false)}
          open={dialogState.isOpen}
          isLoading={dialogState.isLoading}
          size="md"
          centered
          closeButton
        >
          <Dialog.Body>
            <iframe
              style={{ height: '550px', width: '100%' }}
              src={sizesPopupLink.url}
              onLoad={() =>
                setDialogState((state) => ({ ...state, isLoading: false }))
              }
            />
          </Dialog.Body>
        </Dialog>
      )}
    </>
  );
};

export default SizeChart;
